const en = {
  menuMessage:{ 
    home:'home',
    product: 'products',
    new: 'news&updates',
    about: 'aboutUs',
    contact: 'contactUs'
  },
  contactUs: {
    contact: 'contactUs',
    phone: 'phone',
    email: 'email',
    address: 'address'
  }
}
export default en;
